const isIOS = () => !!navigator.userAgent.match(/iPhone|iPad|iPod/i);

export {
  isIOS,
};
